import { Component, OnInit, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { DvsUtilities, RECENT_OPERATIONS_LIMIT } from "src/app/dvs-utilities";
import { DatetimePipe, RuntimePipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { DayPickerComponent } from "src/app/shared/day-picker/day-picker.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-mech-maintenance",
	templateUrl: "./mech-maintenance.component.html",
	styleUrls: ["./mech-maintenance.component.scss"],
	imports: [ActionButtonComponent, DayPickerComponent, FormsModule, DatetimePipe, RuntimePipe]
})
export class MechMaintenanceComponent implements OnInit {
	api = inject(ApiService);
	readonly RECENT_OPERATIONS_LIMIT = RECENT_OPERATIONS_LIMIT;

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public GetOpClass = DvsUtilities.GetOpClass;

	public logs: APIResults.MaintenanceHistory[];
	public allLRUs: AssemblyConfig.LRUDef[];

	/** Date of new maintenance op, only for fixed assets */
	public newDate: string;
	public operations: APIResults.Operation[];
	public selectedOperation: APIResults.Operation;
	public newLRU: AssemblyConfig.LRUDef;
	public newSummary: string;

	async ngOnInit() {
		this.allLRUs = [{
			id: null,
			name: "A/C (all components)",
		}, ...this.components.lru];
		this.newLRU = this.allLRUs[0];
		this.updateLogs();
		this.updateOperations();
	}

	async updateLogs() {
		this.logs = undefined;
		const result = await this.api.GetMaintenanceHistory(this.asset.asset_id);
		this.logs = result;
	}

	async updateOperations() {
		this.operations = undefined;
		const operations = await this.api.GetOperationsWithEnd(this.asset.asset_id, RECENT_OPERATIONS_LIMIT);
		this.operations = operations;
		if (this.operations.length > 0) {
			this.selectedOperation = this.operations[0];
		}
	}

	lookupLRU(id: number) {
		const lru = this.allLRUs.find(item => item.id === id);
		if (lru) {
			return lru.name;
		}
		return "????";
	}

	async UploadMaintenance() {
		let ts;
		if (this.asset.is_fixed) {
			ts = this.newDate + "Z";
		} else {
			ts = this.selectedOperation.end_time.toISOString()
		}
		await this.api.UploadMaintenance(this.asset.asset_id, ts, this.newLRU.id, this.newSummary);
		await this.updateLogs();
		this.newSummary = undefined;
	}

	async DeleteMaintenance(id: number) {
		await this.api.DeleteMaintenance(this.asset.asset_id, id);
		await this.updateLogs();
	}
}
